
<template>
    <svg width="26" height="26" viewBox="0 0 26 26" fill="#151515" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.5 5.41667C6.21268 5.41667 5.93713 5.5308 5.73397 5.73397C5.5308 5.93713 5.41667 6.21268 5.41667 6.5V21.6667C5.41667 21.954 5.5308 22.2295 5.73397 22.4327C5.93713 22.6359 6.21268 22.75 6.5 22.75H19.5C19.7873 22.75 20.0629 22.6359 20.266 22.4327C20.4692 22.2295 20.5833 21.954 20.5833 21.6667V6.5C20.5833 6.21268 20.4692 5.93713 20.266 5.73397C20.0629 5.5308 19.7873 5.41667 19.5 5.41667H17.3333C16.735 5.41667 16.25 4.93164 16.25 4.33333C16.25 3.73502 16.735 3.25 17.3333 3.25H19.5C20.362 3.25 21.1886 3.59241 21.7981 4.2019C22.4076 4.8114 22.75 5.63805 22.75 6.5V21.6667C22.75 22.5286 22.4076 23.3553 21.7981 23.9648C21.1886 24.5743 20.362 24.9167 19.5 24.9167H6.5C5.63805 24.9167 4.8114 24.5743 4.2019 23.9648C3.59241 23.3553 3.25 22.5286 3.25 21.6667V6.5C3.25 5.63805 3.59241 4.8114 4.2019 4.2019C4.8114 3.59241 5.63805 3.25 6.5 3.25H8.66667C9.26498 3.25 9.75 3.73502 9.75 4.33333C9.75 4.93164 9.26498 5.41667 8.66667 5.41667H6.5Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.21859 1.71663C8.62492 1.3103 9.17602 1.08203 9.75065 1.08203H16.2507C16.8253 1.08203 17.3764 1.3103 17.7827 1.71663C18.189 2.12296 18.4173 2.67406 18.4173 3.2487V5.41536C18.4173 5.99 18.189 6.5411 17.7827 6.94743C17.3764 7.35376 16.8253 7.58203 16.2507 7.58203H9.75065C9.17601 7.58203 8.62491 7.35376 8.21859 6.94743C7.81226 6.5411 7.58398 5.99 7.58398 5.41536V3.2487C7.58398 2.67406 7.81226 2.12296 8.21859 1.71663ZM16.2507 3.2487H9.75065L9.75065 5.41536H16.2507V3.2487Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.916 11.9154C11.916 11.3171 12.401 10.832 12.9993 10.832H17.3327C17.931 10.832 18.416 11.3171 18.416 11.9154C18.416 12.5137 17.931 12.9987 17.3327 12.9987H12.9993C12.401 12.9987 11.916 12.5137 11.916 11.9154Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.916 17.3333C11.916 16.735 12.401 16.25 12.9993 16.25H17.3327C17.931 16.25 18.416 16.735 18.416 17.3333C18.416 17.9316 17.931 18.4167 17.3327 18.4167H12.9993C12.401 18.4167 11.916 17.9316 11.916 17.3333Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.58398 11.9154C7.58398 11.3171 8.06901 10.832 8.66732 10.832H8.67815C9.27646 10.832 9.76148 11.3171 9.76148 11.9154C9.76148 12.5137 9.27646 12.9987 8.67815 12.9987H8.66732C8.06901 12.9987 7.58398 12.5137 7.58398 11.9154Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.58398 17.3333C7.58398 16.735 8.06901 16.25 8.66732 16.25H8.67815C9.27646 16.25 9.76148 16.735 9.76148 17.3333C9.76148 17.9316 9.27646 18.4167 8.67815 18.4167H8.66732C8.06901 18.4167 7.58398 17.9316 7.58398 17.3333Z"
        />
    </svg>
</template>
<script>
export default {
    name: "CheckListIcon"
}
</script>
